import { Database, Q } from '@nozbe/watermelondb'
import { Message } from '../model'

export const findMessageByMessageId = async (messageId: string, database: Database): Promise<Message | undefined> => {
  try {
    const messages = database.collections.get<Message>('messages')
    return await database.read(async () => {
      const fetchMessages = await messages.query(Q.where('message_id', Q.eq(messageId))).fetch()
      if (fetchMessages.length) return fetchMessages[0]
      else return undefined
    })
  } catch (e) {
    console.error(e)
  }
}
